import axios from "axios";
import { GET_AVAILABLE_PSYCHS } from "../types";

export function getAvailablePsychs() {
    return async (dispatch) => {
        try {
            const { data } = await axios.get("psych/available");
            dispatch({ type: GET_AVAILABLE_PSYCHS, payload: data });
        } catch (e) {
            console.error("Error fetching available psychologists:", e);
        }
    };
}
